import React, { Component } from "react";
import PropTypes from "prop-types";
import Spinner from "../Spinner";
import Fade from "./Fade";
import Backdrop from "./Backdrop";
import Form from "./Form";
import Container from "./Container";

class CountrySelector extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ lastActiveElement: document.activeElement });
    }
  }

  handleClose = () => {
    const { lastActiveElement } = this.state;
    const { onClose } = this.props;

    onClose();
    lastActiveElement.focus();
  };

  render() {
    const {
      alternateUrls,
      country,
      hasSetCurrencyError,
      hasVoucherError,
      isLoading,
      isOpen,
      noOfProductsInBag,
      onCountryChange,
      onSubmit,
      regionalStore
    } = this.props;

    return (
      <Fade isActive={isOpen}>
        <Backdrop />
        <Container
          onClose={this.handleClose}
          isLoading={isLoading}
          withError={hasVoucherError || hasSetCurrencyError}
        >
          {isLoading || country == null ? (
            <Spinner size="x-large" />
          ) : (
            <Form
              {...country}
              hasSetCurrencyError={hasSetCurrencyError}
              hasVoucherError={hasVoucherError}
              noOfProductsInBag={noOfProductsInBag}
              onClose={this.handleClose}
              onCountryChange={onCountryChange}
              onSubmit={onSubmit}
              regionalStore={regionalStore}
              storeUrl={
                alternateUrls &&
                alternateUrls[country.lang] &&
                alternateUrls[country.lang].url
              }
            />
          )}
        </Container>
      </Fade>
    );
  }
}

CountrySelector.propTypes = {
  alternateUrls: PropTypes.object,
  country: PropTypes.object,
  hasVoucherError: PropTypes.bool,
  hasSetCurrencyError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  noOfProductsInBag: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  regionalStore: PropTypes.shape({
    countryCode: PropTypes.string,
    storeCode: PropTypes.string,
    siteId: PropTypes.number,
    currency: PropTypes.string,
    language: PropTypes.string,
    countryName: PropTypes.string,
    sizeSchema: PropTypes.string
  })
};

export default CountrySelector;
